export const PERM = {
  DASHBOARD_VIEW: 'dashboard:view',
  USERS_MANAGE: 'users:manage',
  PERMISSIONS_MANAGE: 'permissions:manage',
  LOGS_VIEW: 'logs:view',
  TEAMS_MANAGE: 'teams:manage',
  WORKERS_IMPORT: 'workers:import',
  SIGN_PARTY_ROLES: 'sign:party-roles',
  SIGN_TEMPLATES: 'sign:templates',
  SIGN_TASKS: 'sign:tasks',
  SIGN_RECORDS: 'sign:records',
  EXAM_QUESTIONS_VIEW: 'exam:questions:view',
  EXAM_QUESTIONS_MANAGE: 'exam:questions:manage',
  EXAM_PAPERS: 'exam:papers',
  EXAM_TASKS: 'exam:tasks',
  EXAM_RECORDS: 'exam:records',
  FILES_VIEW: 'files:view',
  ENTRY_PROGRAMS: 'entry:programs',
  ENTRY_FLOWS: 'entry:flows',
  TRAINING_TASKS: 'training:tasks',
  TRAINING_RECORDS: 'training:records'
}

export const ROUTE_PERMISSIONS = {
  '/dashboard': [PERM.DASHBOARD_VIEW],
  '/projects': [PERM.USERS_MANAGE],
  '/users': [PERM.USERS_MANAGE],
  '/permissions': [PERM.PERMISSIONS_MANAGE],
  '/sign/party-roles': [PERM.SIGN_PARTY_ROLES],
  '/sign/templates': [PERM.SIGN_TEMPLATES],
  '/sign/party-companies': [PERM.SIGN_TEMPLATES],
  '/sign/tasks': [PERM.SIGN_TASKS],
  '/sign/records': [PERM.SIGN_RECORDS],
  '/exam/questions': [PERM.EXAM_QUESTIONS_VIEW, PERM.EXAM_QUESTIONS_MANAGE],
  '/change-password': [],
  '/files': [PERM.FILES_VIEW],
  '/logs': [PERM.LOGS_VIEW],
  '/entry/docs': [PERM.FILES_VIEW],
  '/entry/personnel-class': [PERM.FILES_VIEW],
  '/entry/training': [PERM.TRAINING_TASKS],
  '/entry/training/1': [PERM.TRAINING_TASKS],
  '/entry/training/2': [PERM.TRAINING_TASKS],
  '/entry/training/3': [PERM.TRAINING_TASKS],
  '/entry/training/4': [PERM.TRAINING_TASKS],
  '/entry/contract': [PERM.SIGN_TASKS],
  '/entry/commitment': [PERM.SIGN_TASKS],
  '/entry/responsibility': [PERM.SIGN_TASKS],
  '/entry/sign-overview': [PERM.SIGN_TASKS],
  '/entry/overview': [PERM.FILES_VIEW, PERM.TRAINING_RECORDS, PERM.SIGN_RECORDS, PERM.EXAM_RECORDS],
  '/entry/worker-archive': [PERM.FILES_VIEW],
  '/entry/programs': [PERM.ENTRY_PROGRAMS],
  '/entry/flows': [PERM.ENTRY_FLOWS],
  '/exam/scores': [PERM.EXAM_RECORDS, PERM.EXAM_TASKS],
  '/training/tasks': [PERM.TRAINING_TASKS],
  '/training/records': [PERM.TRAINING_RECORDS],
}

export function getPermissions(user) {
  return (user && user.permissions) || []
}

export function hasPermission(user, code) {
  if (user && user.roleCode === 'SUPER_ADMIN') return true
  return getPermissions(user).includes(code)
}

export function isReadOnlyAdmin(user) {
  return !!(user && user.roleCode === 'PROJECT_SUPERVISOR')
}

export function isProjectScopedAdmin(user) {
  return !!(user && (user.roleCode === 'PROJECT_ADMIN' || user.roleCode === 'PROJECT_SUPERVISOR'))
}

export function hasAnyPermission(user, codes) {
  if (!codes || !codes.length) return true
  return codes.some(code => hasPermission(user, code))
}

export function canAccessRoute(user, path) {
  if (user && user.roleCode === 'SUPER_ADMIN') {
    if (path === '/entry/doc-options') return true
    if (path.startsWith('/entry/')) return false
  }
  if (path === '/system/wechat' || path === '/entry/doc-options') {
    return user && user.roleCode === 'SUPER_ADMIN'
  }
  if (path === '/sign/party-companies' || path === '/sign/templates') {
    return user && user.roleCode === 'SUPER_ADMIN'
  }
  if (path === '/change-password') {
    return !!user
  }
  const codes = ROUTE_PERMISSIONS[path]
  if (!codes || !codes.length) return true
  return hasAnyPermission(user, codes)
}

export function defaultHomePath(user) {
  const order = [
    '/dashboard',
    '/exam/questions',
    '/permissions',
    '/sign/templates',
    '/entry/docs',
    '/files',
    '/projects',
    '/users'
  ]
  for (const path of order) {
    if (canAccessRoute(user, path)) return path
  }
  return null
}
